import {Chrono} from 'react-chrono'
import ProjectTimelineCard from '../ProjectTimelineCard'
import CourseTimelineCard from '../CourseTimelineCard'
import './index.css'

const TimelineView = props => {
  const {timelineItemsList} = props

  return (
    <div>
      <h1 className="main-heading">MY JOURNEY OF CCBP 4.0</h1>
      <Chrono mode="VERTICAL_ALTERNATING" items={timelineItemsList}>
        {timelineItemsList.map(eachItem =>
          eachItem.categoryId === 'PROJECT' ? (
            <ProjectTimelineCard key={eachItem.id} details={eachItem} />
          ) : (
            <CourseTimelineCard key={eachItem.id} details={eachItem} />
          ),
        )}
      </Chrono>
    </div>
  )
}

export default TimelineView
